<fury-page-layout [@fadeInUp] class="card">
    <fury-page-layout-header>
        <fury-breadcrumbs current="Change Password"></fury-breadcrumbs>
      </fury-page-layout-header>
    <fury-page-layout-content>
    
        <form [formGroup]="changePasswordForm">
            <div class="passwordwrap">
                <mat-form-field fxFlex="grow" appearance="outline">
                    <mat-label>Old Password</mat-label>
                    <input matInput formControlName="oldPassword" [type]="inputTypeOld">
                    <button (click)="toggleVisibilityOld()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                    type="button">
                    <mat-icon *ngIf="visibleOld">visibility</mat-icon>
                    <mat-icon *ngIf="!visibleOld">visibility_off</mat-icon>
                </button>
                    <mat-error *ngIf="changePasswordForm.controls['oldPassword'].hasError('required')">Old password
                        required.</mat-error>
                </mat-form-field>
    
                <mat-form-field fxFlex="grow" appearance="outline">
                    <mat-label>New Password</mat-label>
                    <input matInput formControlName="newPassword" [type]="inputType">
                    <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                        type="button">
                        <mat-icon *ngIf="visible">visibility</mat-icon>
                        <mat-icon *ngIf="!visible">visibility_off</mat-icon>
                    </button>
                    <mat-error *ngIf="changePasswordForm.controls['newPassword'].hasError('required')">New password
                        required.</mat-error>
                </mat-form-field>
    
                <mat-form-field fxFlex="grow" appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput formControlName="confirmPassword" [type]="inputTypeConfirm">
                    <button (click)="toggleVisibilityConfirm()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                        type="button">
                        <mat-icon *ngIf="visibleConfirm">visibility</mat-icon>
                        <mat-icon *ngIf="!visibleConfirm">visibility_off</mat-icon>
                    </button>
                    <mat-error *ngIf="changePasswordForm.controls['confirmPassword'].hasError('required')">Confirm password
                        is required.</mat-error>
                    <mat-error *ngIf="changePasswordForm.controls['confirmPassword'].hasError('valuesDoNotMatch')">Password
                        do not match.</mat-error>
                </mat-form-field>
    
                <div>
                    <button type="button" class="sub-button" mat-raised-button (click)="changePassword()">
                        <span> Change </span>
                    </button>
                </div>
            </div>
            
        </form>
    </fury-page-layout-content>
</fury-page-layout>


